import React, { useRef } from "react";
import QRCode from "qrcode.react";
import { downloadSvg, downloadImageFromCanvas } from "../utils";
import Button from "components/base/Button";

const ShortenLinkQRCode = ({ name, shorternLink }) => {
  const qrcodeContainerRef = useRef();

  return (
    <div className="flex space-x-6 items-end">
      <div ref={qrcodeContainerRef}>
        <QRCode renderAs="svg" value={shorternLink} size={48} />
        <QRCode
          renderAs="canvas"
          value={shorternLink}
          size={300}
          className="hidden"
        />
      </div>
      <div className="flex justify-center space-x-4">
        <Button
          onClick={() =>
            downloadSvg(
              qrcodeContainerRef.current.children[0],
              `${name}-shortern-link`,
            )
          }
        >
          Download SVG
        </Button>

        <Button
          onClick={() =>
            downloadImageFromCanvas(
              qrcodeContainerRef.current.children[1],
              name + "-shortern-link",
              "png",
            )
          }
        >
          Download PNG
        </Button>

        <Button
          title="JPG"
          onClick={() =>
            downloadImageFromCanvas(
              qrcodeContainerRef.current.children[1],
              name + "-shortern-link",
              "jpg",
            )
          }
        >
          Download JPG
        </Button>
      </div>
    </div>
  );
};

export default ShortenLinkQRCode;
